/* @flow */
import { eventSettingsActionMaker } from '@website/components/ActionMakers'

export default () => {
  return {
    eventSettingsActionMaker
  }
}
